import { gql } from "@apollo/client";
import type { IBuySellItem } from "types/BuySell.type";

export interface ICreateBuySellItemInput {
  title: string;
  description?: string;
  price: number;
  currency?: string;
  category?: string;
  condition?: string;
  status?: string;
  images?: string[];
}

export interface IUpdateBuySellItemInput extends Partial<ICreateBuySellItemInput> {
  id: string;
}

export interface IBuySellItemMutationResponse {
  createBuySellItem?: IBuySellItem;
  updateBuySellItem?: IBuySellItem;
  deleteBuySellItem?: IBuySellItem;
  markBuySellItemAsSold?: IBuySellItem;
}

const BUY_SELL_ITEM_MUTATION_FIELDS = gql`
  fragment BuySellItemMutationFields on BuySellItem {
    id
    title
    description
    price
    currency
    category
    condition
    status
    images
    createdAt
    updatedAt
    soldAt
    sellerId
    canManage
    seller {
      id
      name
      lastname
      profileImage
      email
    }
  }
`;

const CREATE_BUY_SELL_ITEM = gql`
  ${BUY_SELL_ITEM_MUTATION_FIELDS}
  mutation CreateBuySellItem($createBuySellItemInput: CreateBuySellItemInput!) {
    createBuySellItem(createBuySellItemInput: $createBuySellItemInput) {
      ...BuySellItemMutationFields
    }
  }
`;

const UPDATE_BUY_SELL_ITEM = gql`
  ${BUY_SELL_ITEM_MUTATION_FIELDS}
  mutation UpdateBuySellItem($updateBuySellItemInput: UpdateBuySellItemInput!) {
    updateBuySellItem(updateBuySellItemInput: $updateBuySellItemInput) {
      ...BuySellItemMutationFields
    }
  }
`;

const DELETE_BUY_SELL_ITEM = gql`
  mutation DeleteBuySellItem($id: String!) {
    deleteBuySellItem(id: $id) {
      id
    }
  }
`;

const MARK_BUY_SELL_ITEM_AS_SOLD = gql`
  ${BUY_SELL_ITEM_MUTATION_FIELDS}
  mutation MarkBuySellItemAsSold($id: String!) {
    markBuySellItemAsSold(id: $id) {
      ...BuySellItemMutationFields
    }
  }
`;

export default {
  CREATE_BUY_SELL_ITEM,
  UPDATE_BUY_SELL_ITEM,
  DELETE_BUY_SELL_ITEM,
  MARK_BUY_SELL_ITEM_AS_SOLD,
};
